import axios from 'axios';

import { config } from '../../config';
import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useSignOutStore from '../signOutStore/useSignOutStore';
import useUserStore from '../userStore/useUserStore';
import { apiStore } from './apiStore';
import { HttpClient } from './types/HttpClient';

const useApiStore = createStore({
  creator: apiStore({
    config,
    // apiStore's response interceptors return `response.data`, which is what
    // HttpClient models. axios types its methods as returning the full
    // response (a conditional type since 1.20), so it cannot be assigned
    // structurally
    httpClient: axios as unknown as HttpClient,
    useSignOutStore: lazyDependency(() => useSignOutStore),
    useUserStore: lazyDependency(() => useUserStore),
  }),
  id: 'api',
  middlewares: {
    devtools: true,
  },
});

export default useApiStore;
